import { OrderTypeSchema } from '~/services/api/generated'
import type { OrderType } from './OrderType'

export function isOrderType(value: unknown): value is OrderType {
  return OrderTypeSchema.validate(value)
}
